import React, { memo } from "react";
import { StyleSheet, View } from "react-native";
import Text from "@components/CustomText";
import Tick from "@assets/svg/Tick";
import { formatClockTime } from "@utils/attendance";
import { ATTENDANCE_COLORS as C } from "./constants";

interface Props {
  title: string;
  timeLabel: "In Time" | "Out Time";
  capturedAt: string;
  testID?: string;
}

const Row = ({ label, value }: { label: string; value: string }) => (
  <View style={styles.row}>
    <Text style={styles.rowLabel}>{label}</Text>
    <Text style={styles.rowValue}>{value}</Text>
  </View>
);

/** Green summary card for a completed IN or OUT entry. */
const MarkedCard = ({ title, timeLabel, capturedAt, testID }: Props) => (
  <View
    testID={testID}
    style={styles.card}
    accessible
    accessibilityLabel={`${title}. Marked. ${timeLabel} ${formatClockTime(capturedAt)}. Selfie submit successful.`}
  >
    <View style={styles.header}>
      <View style={styles.badge}>
        <Tick width={22} height={22} strokeColor={C.white} />
      </View>
      <View style={styles.texts}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.subtitle}>Marked</Text>
      </View>
    </View>
    <View style={styles.divider} />
    <Row label={timeLabel} value={formatClockTime(capturedAt)} />
    <Row label="Selfie Submit" value="Successful" />
  </View>
);

export default memo(MarkedCard);

const styles = StyleSheet.create({
  card: { backgroundColor: C.marked, borderRadius: 14, padding: 18 },
  header: { flexDirection: "row", alignItems: "center" },
  badge: {
    width: 44,
    height: 44,
    borderRadius: 11,
    backgroundColor: C.badgeBg,
    alignItems: "center",
    justifyContent: "center",
  },
  texts: { marginLeft: 14, flex: 1 },
  title: { color: C.white, fontSize: 17, fontWeight: "700" },
  subtitle: { color: C.onColorSoft, fontSize: 13, marginTop: 2 },
  divider: { height: 1, backgroundColor: C.divider, marginVertical: 12 },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  rowLabel: { color: C.onColorSoft, fontSize: 13 },
  rowValue: { color: C.white, fontSize: 13, fontWeight: "600" },
});
